import { createRouter, createWebHashHistory } from 'vue-router'
import Index from '../pages/index'
import IndexPC from '../pages/indexPC'
let routes = []
//判断访问终端
const browser = {
    versions: function () {
        let u = navigator.userAgent;
        // let appVersion = navigator.appVersion;
        return {
            trident: u.indexOf('Trident') > -1,                            //IE内核
            presto: u.indexOf('Presto') > -1,                              //opera内核
            webKit: u.indexOf('AppleWebKit') > -1,                         //苹果、谷歌内核
            gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1,    //火狐内核
            mobile: !!u.match(/AppleWebKit.*Mobile.*/),                    //是否为移动终端
            ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),               //ios终端
            android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, //android终端或者uc浏览器
            iPhone: u.indexOf('iPhone') > -1,                              //是否为iPhone或者QQHD浏览器
            iPad: u.indexOf('iPad') > -1,                                  //是否iPad
            webApp: u.indexOf('Safari') == -1,                             //是否web应该程序，没有头部与底部
            weixin: u.indexOf('MicroMessenger') > -1,                      //是否微信 （2015-01-22新增）
            qq: u.match(/\sQQ/i) == " qq"                                  //是否QQ
        };
    }(),
    language: (navigator.browserLanguage || navigator.language).toLowerCase()
};
// 判断是否为移动端
if (browser.versions.mobile || browser.versions.android || browser.versions.ios) {
    console.info("移动端");
    routes = [
        // 下面的对象就是路由记录
        {
            path: '/',
            component: Index,
        },
        {
            path: '/list',
            component: () => import('../pages/list'),
        },
        {
            path: '/detail',
            component: () => import('../pages/detail'),
        }
    ]
} else {
    console.info("非移动端");
    routes = [
        // 下面的对象就是路由记录
        {
            path: '/',
            component: IndexPC,
        },
        {
            path: '/listPc',
            component: () => import('../pages/listPc'),
        },
        {
            path: '/detailPc',
            component: () => import('../pages/detailPc'),
        }
    ]
}


// 3. 创建路由实例并传递 `routes` 配置
// 你可以在这里输入更多的配置，但我们在这里
// 暂时保持简单
const hashHistory = createWebHashHistory()
const router = createRouter({
    // 4. 内部提供了 history 模式的实现。为了简单起见，我们在这里使用 hash 模式。
    history: hashHistory,
    routes, // `routes: routes` 的缩写
})

export default router